module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-f8854015.png";